var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9.996 7.5c.175-.302.383-.703.593-1.204.275-.656.556-1.487.771-2.498a19.728 19.728 0 0 0-2.736 0c.215 1.01.496 1.842.77 2.498.211.501.419.902.594 1.204h.008ZM12 13.25c.587 0 1.158.024 1.707.066a19.951 19.951 0 0 0 .022-2.234 22.334 22.334 0 0 1-3.458 0 20.202 20.202 0 0 0 .022 2.234c.549-.042 1.12-.066 1.707-.066Zm-1.447-4.654c.223-1.19.54-2.152.85-2.892.21-.501.418-.902.593-1.204h.008c.175.302.383.703.593 1.204.31.74.627 1.701.85 2.892a19.772 19.772 0 0 1-2.894 0Zm5.663 2.16a22.59 22.59 0 0 1-.025 2.883 24.958 24.958 0 0 1 2.93.722c.246-.742.379-1.536.379-2.361a7.51 7.51 0 0 0-.269-1.997 24.997 24.997 0 0 1-3.015.752Zm1.943-3.037a22.458 22.458 0 0 1-2.23.547 17.114 17.114 0 0 0-.859-3.11 7.529 7.529 0 0 1 3.089 2.563Zm-10.087.547a22.465 22.465 0 0 1-2.23-.547 7.53 7.53 0 0 1 3.087-2.564 17.12 17.12 0 0 0-.857 3.111Zm-3.303 1.737a24.989 24.989 0 0 0 3.015.752 22.62 22.62 0 0 0 .025 2.884 24.956 24.956 0 0 0-2.93.722A7.493 7.493 0 0 1 4.5 12c0-.691.094-1.361.269-1.997Zm10.302 8.842c.292-.762.57-1.67.784-2.726a22.539 22.539 0 0 1 2.062.49 7.526 7.526 0 0 1-2.847 2.236Zm-6.142 0a7.527 7.527 0 0 1-2.846-2.236 22.487 22.487 0 0 1 2.062-.49c.213 1.056.492 1.964.784 2.726Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe24);
export default __webpack_public_path__ + "static/media/globe_24.e815379a.svg";
export { ForwardRef as ReactComponent };